import { useRef, useLayoutEffect } from 'react';

const isBrowser = typeof window !== `undefined`;

function getScrollPosition({ element, usingWindow }) {
  if (!isBrowser) return { x: 0, y: 0 };

  const target = element ? element.current : document.body;
  const position = target.getBoundingClientRect();

  return usingWindow
    ? { x: window.scrollX, y: window.scrollY }
    : { x: position.left, y: position.top };
}

function useScrollPosition(effect, deps, element, usingWindow, ms) {
  const position = useRef(
    typeof window !== `undefined` ? getScrollPosition({ usingWindow }) : null
  );
  const throttleTimeout = useRef(null);

  const callback = () => {
    const currPos = getScrollPosition({ element, usingWindow });
    effect({ prevPos: position.current, currPos });
    position.current = currPos;
    throttleTimeout.current = null;
  };

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (ms) {
        if (throttleTimeout.current === null) {
          throttleTimeout.current = setTimeout(callback, ms);
        }
      } else {
        callback();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useScrollPosition;
